import { c as _c } from "react/compiler-runtime";
import { Link, type LinkProps } from '@mui/material';
import type { ReactNode } from 'react';
import { useScrollIntoView } from './useScrollIntoView';
export type InternalScrollLinkProps = {
  target: string;
  children: ReactNode;
  scrollTopMargin?: string;
  linkProps?: LinkProps;
  onClickAnalyticsCallback?: () => void;
};
export function InternalScrollLink(t0) {
  const $ = _c(8);
  const {
    children,
    target,
    scrollTopMargin,
    linkProps,
    onClickAnalyticsCallback
  } = t0;
  const scrollIntoView = useScrollIntoView(target, scrollTopMargin);
  let t1;
  if ($[0] !== onClickAnalyticsCallback || $[1] !== scrollIntoView) {
    t1 = e => {
      scrollIntoView(e);
      if (onClickAnalyticsCallback) {
        onClickAnalyticsCallback();
      }
    };
    $[0] = onClickAnalyticsCallback;
    $[1] = scrollIntoView;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClick = t1;
  const t2 = `#${target}`;
  let t3;
  if ($[3] !== children || $[4] !== handleClick || $[5] !== linkProps || $[6] !== t2) {
    t3 = <Link href={t2} rel="nofollow noopener noreferrer" target="_self" onClick={handleClick} {...linkProps}>{children}</Link>;
    $[3] = children;
    $[4] = handleClick;
    $[5] = linkProps;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}